import React from 'react';
import '../../stylesheets/stylesLayout/header/generalHeader.scss';
import UserMenu from './userMenu/UserMenu';
import GenericMenu from './GenericMenu';
import { useAuth } from '../../contexts/AuthContext';
import Activity from './activity/Activity';

export default function GeneralHeader({ menuData, isVisible, isExternalPage }) {
    const { isAuthenticated } = useAuth();
    const style = isVisible ? 'header__container' : 'display-none';
    const isVisibleGenericMenu = !isExternalPage;
    return (
        <header className={style}>
            <a
                className='logo__header'
                href='https://www.fastpayhotels.com/'
                aria-label='logo image to home'
                alt='logo image to home'
            />
            <div className='language__navbar--container'>
                {isVisibleGenericMenu && <GenericMenu menuData={menuData} />}
                {isAuthenticated && <Activity />}
                {isAuthenticated && <UserMenu />}
            </div>
        </header>
    );
}
